const appInfo = {
    title: 'Pathta'
};
export default appInfo;

